@if (attachmentsArr) {
<div class="attachments-container d-flex flex-wrap mb-3">
	@for (atc of attachmentsArr; track $index) {
	<div class="attachment position-relative m-0 d-flex align-items-center">
		@if (allowBillingLink && apptId) {
		<mat-checkbox [(ngModel)]="atc.selected" color="primary" class="me-2"></mat-checkbox>
		}
		<a matTooltip="{{getName(atc.orig_name || atc.file_name)}}" href="{{atc.url}}" target="_blank"
			class="d-flex align-items-center text-decoration-none">
			<img [src]="isImage(atc.file_name)?atc.url:defaultIcon"
				alt="{{getShortName(atc.orig_name || atc.file_name)}}" class="attachment-thumb me-2" />
		</a>
		<span class="attachment-name" matTooltip="{{getName(atc.orig_name || atc.file_name)}}">
			{{getName(atc.orig_name || atc.file_name)}}
		</span>
		@if (showDelete) {
		<button mat-icon-button color="warn" class="ms-2 delete-btn" (click)="removeAttachment(atc)"
			matTooltip="Remove">
			<fa-icon [icon]="['fas','times']"></fa-icon>
		</button>
		}
	</div>
	}
</div>

@if (allowBillingLink && apptId) {
<div class="attachments-container d-flex flex-wrap gap-2 pt-2 border-top">
	<button mat-stroked-button color="primary" (click)="selectFiles('bill')"
		class="d-inline-flex align-items-center justify-content-center">
		<fa-icon [icon]="['fas', 'file-invoice-dollar']" class="me-2"></fa-icon>
		Select for billing
	</button>
	<button mat-stroked-button (click)="selectFiles('file')"
		class="d-inline-flex align-items-center justify-content-center">
		<fa-icon [icon]="['fas', 'file-alt']" class="me-2"></fa-icon>
		Select for files
	</button>
</div>
}
}